import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { ProcessedCash } from "@/model/data/logAnalysis/ProcessedCash";

export class GetProcessedCashResData extends ApiGenericResponse {
    processedCash: ProcessedCash[];

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ProcessedCash) {
            this.processedCash = new Array()
            obj.ProcessedCash.forEach(element => {
                let pc = new ProcessedCash();
                pc.parse(element);
                this.processedCash.push(pc);
            }); 
        }
    }
}
